import { transparentTag as css } from '@tencent/exeditor3-core';
export const fileStyles = css `
  .exeditor-file-uploading {
    display: block;
    position: relative;
    width: fit-content;
    max-width: 100%;
    height: auto;
    margin: 1em auto;
    color: #999;
  }
  .exeditor-file-uploading > span {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
  }
  .exeditor-file-uploading > :first-child {
    display: block;
    max-width: 100%;
    height: auto;
    opacity: 0.2;
    filter: blur(5px);
  }
  /* inline */
  span.exeditor-file-uploading {
    display: inline-block;
    margin: 0 2px;
  }
`;
//# sourceMappingURL=styles.js.map